// extracted by mini-css-extract-plugin
export default {"trigger":"src-layout-MainPagesLayout-css__trigger--OStEi"};